import './index.css';
import Drawer from '@mui/material/Drawer';
import { Text, View } from '../../../component';
import { useDispatch, useSelector } from 'react-redux';
import useTheme from '../../../utilities/hooks/theme';
import Constants from '../../../constants';
import I18n from '../../../utilities/locale';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { IoIosArrowForward } from 'react-icons/io';
import { useLink } from 'react-router-stack';
import Avatar from '@mui/material/Avatar';
import React from 'react';
import constants from '../../../constants';
import { MdLogout } from 'react-icons/md';
import { setIsDrawerOpen, userLogOut } from '../../../actions/user-actions-types';
import { showToast } from '../../../actions/app-actions-types';
interface DrawerItemProps {
  Icon: any;
  linkText: any;
  onPress: any;
  theme: any;
  isShowArrow: boolean;
}
const DrawerItem = ({ isShowArrow = false, Icon, linkText, onPress, theme }: DrawerItemProps) => {
  const linkTextColor = {
    color: theme.drawerMenuTitle
  };
  return (
    <View onPress={onPress} className={'side-drawer-item-container'}>
      <View className={'side-drawer-item-icon-container'}>{Icon}</View>
      <Text style={linkTextColor} className={'side-drawer-item-link-text'}>
        {linkText}
      </Text>
      <View className="side-drawer-item-arrow-wrapper">
        {isShowArrow && <IoIosArrowForward color={theme.drawerMenuTitle} size={20} />}
      </View>
    </View>
  );
};

interface Props {
  drawerOpen: boolean;
  onPressToggleDrawer: any;
}
const SideDrawer = ({ drawerOpen, onPressToggleDrawer }: Props) => {
  const link = useLink();
  const { DashboardTheme: theme } = useTheme();
  const user = useSelector((state: any) => state.user);
  const { teamName = '', phones = [] } = user;

  const dispatch = useDispatch();

  const onPressItem = (route: any) => {
    onPressToggleDrawer();
    link.push(route, null);
  };

  const containerColor = {
    backgroundColor: theme.drawerBackground
  };

  const drawerHeaderColor = {
    backgroundColor: theme.drawerHeaderBackground
  };

  const emailTextColor = {
    color: theme.drawerHeaderEmailText
  };

  const drawerSx: SxProps<Theme> = {
    '& .MuiPaper-root': {
      overflowY: 'unset'
    }
  };
  const handleLogOut = () => {
    dispatch(userLogOut());
    dispatch(setIsDrawerOpen(!drawerOpen));
    dispatch(showToast('Logged Out Successfully'));
  };

  return (
    <Drawer sx={drawerSx} anchor={'left'} open={drawerOpen} onClose={onPressToggleDrawer}>
      <View
        style={{
          width: '20rem',
          height: '100%'
        }}>
        <View className={'side-drawer-header-container'} style={drawerHeaderColor}>
          <Avatar sx={{ width: 56, height: 56, borderWidth: 0 }}>
            <Constants.Svgs.ProfileAvatar width={'100%'} height={'100%'} />
          </Avatar>
          <View className={'side-drawer-name-email-wrapper'}>
            {phones && phones.length > 0 && (
              <Text className={'side-drawer-name-text'} style={emailTextColor}>
                {`Mobile No :  ${phones[0].phone}`}
              </Text>
            )}
            {teamName !== '' && !teamName.match(/^[0-9a-fA-F]{24}$/) && (
              <Text
                className={'side-drawer-name-text'}
                style={emailTextColor}>{`${teamName}`}</Text>
            )}
          </View>
        </View>
        <div className={'side-drawer-content-wrapper '} style={containerColor}>
          <DrawerItem
            onPress={() => onPressItem('/my_profile')}
            Icon={<Constants.Svgs.Profile />}
            linkText={I18n.t('MyProfile')}
            theme={theme}
            isShowArrow={false}
          />
          <DrawerItem
            onPress={() => onPressItem('/transaction_history')}
            Icon={
              <img
                src={constants.Images.coin}
                width={25}
                height={25}
                color={theme.drawerMenuIcon}
              />
            }
            linkText={'Transaction History'}
            theme={theme}
            isShowArrow={false}
          />
          <DrawerItem
            onPress={handleLogOut}
            Icon={<MdLogout color={'#c005db'} size={25} />}
            linkText={'Log Out'}
            theme={theme}
            isShowArrow={false}
          />
        </div>
      </View>
    </Drawer>
  );
};

export default React.memo(SideDrawer);
